@import '../../../../../constants/spacing.module.less';

.note-count {
  margin-left: @space-8;
  padding: @space-4;
  background: var(--order-details-canvas--info-pill-background--color);
  border: 1px solid var(--order-details-canvas--info-pill-background--color);
  border-radius: 4px;
}

.notes-section-content {
  .od-canvas-fulfillment-plan-notes label,
  .od-canvas-fulfillment-plan-notes textarea {
    color: var(--default--text-color--17);
  }
}
